import React from 'react';
import { Divider } from 'semantic-ui-react';

import { Contexto } from 'src/contexto';
import FormularioPagosEventuales from './FormularioPagosEventuales';
import { TablaPagosEventuales } from './TablaPagosEventuales';
import { PagoEventual } from './tipos';

interface PagosEventualesProps {
    datos: ReadonlyArray<PagoEventual>;
    idPlanDePago: string;
    nombreCompletoApoderado: string;
    rutPasaporte: string;
    alModificarPagos(): void;
}

export class PagosEventuales extends React.Component<PagosEventualesProps, {}> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public render() {
        const { datos, idPlanDePago, nombreCompletoApoderado, rutPasaporte } = this.props;

        return (
            <div>
                <FormularioPagosEventuales
                    idPlanDePago={idPlanDePago}
                    nombreCompletoApoderado={nombreCompletoApoderado}
                    rutPasaporte={rutPasaporte}
                    alRealizarPago={this.props.alModificarPagos}
                />
                <Divider hidden />
                <TablaPagosEventuales
                    idPlanDePago={idPlanDePago}
                    datos={datos}
                    alEditarPago={this.props.alModificarPagos}
                />
            </div>
        );
    }
}

export default PagosEventuales;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/PagosEventuales.tsx